(function ($) {
  $(document).ready(function () {
    $('.tab-menu-area').hide();
    $('.tab-menu-area:first').show();
    $('.tab-menu .tab-menu-btn:first').addClass('active');

    $('.tab-menu .tab-menu-btn').click(function () {
      $('.tab-menu .tab-menu-btn').removeClass('active');
      $(this).addClass('active');
      $('.tab-menu-area').hide();

      $(jQuery(this).attr('href')).fadeIn();
      return false;
    });
  });
})(jQuery);
